

// Have cities consume more electricity than suburban areas
export const SUBURBAN_DEMAND_MULTIPLIER = 1
export const URBAN_DEMAND_MULTIPLIER = 1.5
